import { FormField, FormFieldType } from '@enroller/admissions-components';
import { Trans, useLingui } from '@lingui/react/macro';
import { Grid2, Typography } from '@mui/material';
import { Control, useWatch } from 'react-hook-form';
import { CourseReservation } from './CourseReservation';

interface AdditionalInformationProps {
  control: Control<CourseReservation>;
}

export const AdditionalInformation = ({ control }: AdditionalInformationProps) => {
  const { t } = useLingui();
  const allergiesWatch = useWatch({ control, name: 'studentAllergies' });
  const medicalWatch = useWatch({ control, name: 'studentMedicalTreatment' });
  const dietWatch = useWatch({ control, name: 'studentDietaryRequirements' });
  const learningWatch = useWatch({ control, name: 'studentLearningDifficulties' });

  return (
    <Grid2 container spacing={3} id="additional-information">
      <Grid2 size={12}>
        <Typography variant="subtitle1">
          <Trans>Additional Information</Trans>
        </Typography>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Current school (optional)`} name="studentSchool" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>{/* push 6 */}</Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          label={t`Does the student have any allergies?`}
          type={FormFieldType.Radio}
          name="studentAllergies"
          control={control}
          options={[
            { label: t`Yes`, value: 'true' },
            { label: t`No`, value: 'false' },
          ]}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>{/* push 6 */}</Grid2>
      {allergiesWatch === 'true' && (
        <Grid2 size={12}>
          <FormField type={FormFieldType.Text} name="studentAllergiesSpecifics" control={control} multiline rows={4} />
        </Grid2>
      )}
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          label={t`Is the student currently receiving any medical treatment?`}
          type={FormFieldType.Radio}
          name="studentMedicalTreatment"
          control={control}
          options={[
            { label: t`Yes`, value: 'true' },
            { label: t`No`, value: 'false' },
          ]}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>{/* push 6 */}</Grid2>
      {medicalWatch === 'true' && (
        <Grid2 size={12}>
          <FormField type={FormFieldType.Text} name="studentMedicalTreatmentSpecifics" control={control} multiline rows={4} />
        </Grid2>
      )}
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          label={t`Does the student have any dietary requirements?`}
          type={FormFieldType.Radio}
          name="studentDietaryRequirements"
          control={control}
          options={[
            { label: t`Yes`, value: 'true' },
            { label: t`No`, value: 'false' },
          ]}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>{/* push 6 */}</Grid2>
      {dietWatch === 'true' && (
        <Grid2 size={12}>
          <FormField type={FormFieldType.Text} name="studentDietaryRequirementsSpecifics" control={control} multiline rows={4} />
        </Grid2>
      )}
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          label={t`Does the student have any learning difficulties?`}
          type={FormFieldType.Radio}
          name="studentLearningDifficulties"
          control={control}
          options={[
            { label: t`Yes`, value: 'true' },
            { label: t`No`, value: 'false' },
          ]}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>{/* push 6 */}</Grid2>
      {learningWatch === 'true' && (
        <Grid2 size={12}>
          <FormField type={FormFieldType.Text} name="studentLearningDifficultiesSpecifics" control={control} multiline rows={4} />
        </Grid2>
      )}
    </Grid2>
  );
};
